export const DEFAULT_FPS = 30
export const DEFAULT_FREQUENCY = 48000
